const itemsType = {
  ITEM: 'item',
  TABLE: 'table',
  CHEQUE: 'cheque',
};

export default itemsType;
